import React from 'react';
import {
  Box,
  Select,
  HStack,
  Text,
  Badge,
  Icon,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
} from '@chakra-ui/react';
import { MdPublic } from 'react-icons/md';
import { useEnvironment } from '../../contexts/EnvironmentContext';

const EnvironmentSelector: React.FC = () => {
  const { currentEnvironment, availableEnvironments, switchEnvironment } = useEnvironment();

  return (
    <Menu>
      <MenuButton
        as={Button}
        variant="ghost"
        size="sm"
        _hover={{ bg: 'gray.100' }}
        _active={{ bg: 'gray.200' }}
      >
        <HStack spacing={2}>
          <Text fontSize="sm" fontWeight="medium">
            {currentEnvironment.displayName}
          </Text>
          <Badge
            colorScheme={
              currentEnvironment.name === 'production' ? 'red' :
              currentEnvironment.name === 'preview' ? 'orange' :
              'green'
            }
            fontSize="xs"
          >
            {currentEnvironment.name}
          </Badge>
        </HStack>
      </MenuButton>
      <MenuList>
        {availableEnvironments.map((env) => (
          <MenuItem
            key={env.name}
            onClick={() => switchEnvironment(env.name)}
            bg={currentEnvironment.name === env.name ? 'blue.50' : 'white'}
            _hover={{ bg: 'gray.50' }}
          >
            <HStack spacing={2} w="full">
              <Box
                w="8px"
                h="8px"
                borderRadius="full"
                bg={env.color}
              />
              <Text flex={1}>{env.displayName}</Text>
              {currentEnvironment.name === env.name && (
                <Badge colorScheme="blue" fontSize="xs">Active</Badge>
              )}
            </HStack>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default EnvironmentSelector;

